import React from "react";
import { Line } from "react-chartjs-2";

const BurndownChart = ({ data }) => {

  const chartData = {
    labels: data.map(d => d.day),
    datasets: [
      {
        label: "Remaining Work",
        data: data.map(d => d.remaining),
        borderColor: "#22c55e",
        backgroundColor: "rgba(34,197,94,0.2)",
        tension: 0.3
      }
    ]
  };

  return (
    <div className="bg-gray-800 p-5 rounded-xl border border-gray-700">
      <h3 className="mb-4 font-semibold text-white">🔥 Sprint Burndown</h3>
      <Line data={chartData}/>
    </div>
  );
};

export default BurndownChart;